import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import EdenredButton from '@sharedComponent/button';
import EdenredHeader from '@pages/main-layout/components/main-header';
import EdenredTypo from '@sharedComponent/typography';
import Input from '@sharedComponent/text-field';

const AddPassportNumber = () => {
	const { state } = useLocation();
	const history = useHistory();
	const [form] = Form.useForm();
	const [, forceUpdate] = useState();

	useEffect(() => {
		forceUpdate({});
	}, [forceUpdate]);

	const onFinish = (values) => {
		const { passportNumber } = values;
		if (state.orderType === 'Bank Account') {
			history.push({ pathname: '/employees/add/individual/employee/iban/number', state: { ...state, passportNumber } });
		} else {
			history.push({ pathname: '/employees/add/individual/employee/details/submit/nextsteps', state: { ...state, passportNumber } });
		}
	};
	return (
		<>
			<EdenredHeader />
			<Row className="add_passport_number_container">
				<Col xl={24} lg={24} md={24} sm={24} xs={24} className="add_passport_number_title">
					<EdenredTypo>What Is {state && state.firstName ? state.firstName : ''}’s Passport Number?</EdenredTypo>
				</Col>
				<Col xl={10} lg={20} md={24} sm={24} xs={24} className="add_passport_number_form_section">
					<Form form={form} onFinish={onFinish}>
						<Form.Item
							name="passportNumber"
							rules={[
								{ required: true, message: 'Please provide the Passport Number of the employee' },
								{
									max: 12,
									message: 'Passport Number - Max 12 characters only allowed',
								},
							]}>
							<Input placeholder="XXX000000" labels="Passport Number" labelClassName="inputlabelrequired" />
						</Form.Item>
						<Col xl={18} lg={18} md={24} sm={24} xs={24}>
							<Form.Item shouldUpdate={true}>
								{() => (
									<EdenredButton
										disabled={!form.isFieldsTouched(true) || form.getFieldsError().filter(({ errors }) => errors.length).length}>
										Next
									</EdenredButton>
								)}
							</Form.Item>
						</Col>
					</Form>
				</Col>
			</Row>
		</>
	);
};

export default AddPassportNumber;
